import { render, staticRenderFns } from "./submitBtn.vue?vue&type=template&id=beed13b8&scoped=true&"
import script from "./submitBtn.vue?vue&type=script&lang=ts&"
export * from "./submitBtn.vue?vue&type=script&lang=ts&"
import style0 from "./submitBtn.vue?vue&type=style&index=0&id=beed13b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beed13b8",
  null
  
)

export default component.exports